<template>
  <v-form v-if='person' v-model="formValid">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>{{person.name}}</v-card-title>

        <v-card-text>
          <v-text-field
            @focus="$event.target.select()"
            v-model="person.name"
            :label="`${person.name}'s first name (optional)`"
          ></v-text-field>
          <span>Is patient’s {{person.name}} living?</span>
          <v-radio-group v-model="person.isLiving" true-value="true" false-value="false">
            <v-radio label="Yes" :value="true"></v-radio>
            <v-radio label="No" :value="false"></v-radio>
          </v-radio-group>

          <v-text-field
            @focus="$event.target.select()"
            type="tel"
            pattern="[0-9]*"
            v-model="person.age"
            :label="ageText()"
            :rules='ageRules'
          ></v-text-field>
          <v-select
            :placeholder="`gender of ${person.name}`"
            v-model="person.gender"
            :items="genderList"
          ></v-select>
          <span>Has patient’s {{person.name}} ever been diagnosed with cancer?</span>
          <Cancer v-if="indexNum !== null" :modifyIndex="indexNum"/>
          <span>Has patient’s {{person.name}} completed any genetic testing previously?</span>
          <CancerTest v-if="indexNum !== null" :modifyIndex="indexNum"/>
          <v-textarea v-model="person.notes" outline name="input-7-4" label="Notes (optional)" value></v-textarea>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :disabled="!formValid" color="primary" text @click="save()">Save</v-btn>
        </v-card-actions>
      </v-card>
      </v-form>
</template>

<script>
import Cancer from "./Cancer.vue";
import CancerTest from "./CancerTest.vue";
import { mapFields } from "vuex-map-fields";
export default {
      components: {
    Cancer,
    CancerTest,
    },
    props : {
        indexNum : Number 
    },
    methods : {
           save() {
                    if (this.indexNum === -1) {
                        this.dataModel.push(this.person);
                    } else {
                        this.dataModel[this.indexNum] = this.person;
                    }
                    this.dataModel[this.indexNum] = this.person;
                    this.$emit('closePersonModal')
                 },   
                ageText() {
                    if (this.person.isLiving) {
                        return "What is " + this.person.name + "'s age?";
                    } else {
                        return "What is " + this.person.name + "'s age of passing?";
                    }
                },  
    },
    data(){
        return{
            person : null,
            fieldRules: [v => !!v || "this field is required"],
            ageRules: [v => (v && v >= 0) || 'Age must be larger or equal to 0'],
        }
    },
    mounted() {
      this.person =  this.dataModel[this.indexNum]
    },
    watch :{
        indexNum : function(newVal){
        this.person =  this.dataModel[newVal]
        }
    },
     computed: {
    ...mapFields("patientQuestion", [
      "formValid",
      "dataModel",
      "genderList",
      "snackbar",
      "errorText",
    ])
     }
}
</script>